module.exports = __webpack_public_path__ + "static/media/flyrest-3.2f125f14.jpg";